import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	total: 0,
	page: 1,
	maxPage: 1,
	fetchedProductTransactions: [],
};

const productTransactionsSlice = createSlice({
	name: 'productTransactions',
	initialState: initialState,
	reducers: {
		setProductTransactions: (state, action) => action.payload,
		reset: (state, action) => initialState,
	},
});

export const { setProductTransactions, reset } = productTransactionsSlice.actions;

export default productTransactionsSlice.reducer;